import React, { useEffect, useState } from "react";
import SectionHeader from "../components/SectionHeader";
import { submitDocketEntry } from "../services/docketEntryService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DocketForm from "../components/DocketForm";

const DockerEntry = () => {
  const [formData, setFormData] = useState({
    branchID: "",
    origin: "",
    destination: "",
    transportMode: "",
    docketNumber: "",
    from: {
      name: "",
      address: "",
      phoneNo: "",
      gst: "",
      dropOff: false,
    },
    to: {
      name: "",
      address: "",
      phoneNo: "",
      gst: "",
      selfCollect: false,
    },
    numberOfBoxes: "",
    packageInfo: "",
    invoiceNo: "",
    invoiceDate: "",
    invoiceValue: "",
    eWayBillNo: "",
    boxDimension: "",
    packageType: "",
    saidToContain: "",
    riskCoverage: "",
    policyValidity: "",
    paymentMode: {
      cash: false,
      dd: false,
      cheque: false,
    },
    codAmount: "",
    amountInWords: "",
    numberOfDocuments: "",
    documentsReceived: {
      invoice: false,
      eWaybill: false,
      others: false,
    },
    valueAddedService: {
      appointmentDelivery: false,
      specialDelivery: false,
    },
    // pickUpAgentName: "",
    actualWeight: "",
    chargedWeight: "",
    paymentType: {
      credit: false,
      paid: false,
      fod: false,
    },
    charges: {
      baseFreight: "",
      processingCharge: "",
      fuelSurcharge: "",
      rovCharge: "",
      fodCharge: "",
      handlingCharge: "",
      codDodCharge: "",
      specialDelivery: "",
      otherCharges: "",
      subTotal: "",
      gst: "",
      grandTotal: "",
    },
    modeOfPayment: {
      cash: false,
      chequeDd: false,
      neftRtgs: false,
    },
    chequeNeftNo: "",
    bank: "",
    amountInWordsPayment: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const handleClear = () => {
    setFormData({
      branchID: "",
      origin: "",
      destination: "",
      transportMode: "",
      docketNumber: "",
      from: {
        name: "",
        address: "",
        phoneNo: "",
        gst: "",
        dropOff: false,
      },
      to: {
        name: "",
        address: "",
        phoneNo: "",
        gst: "",
        selfCollect: false,
      },
      numberOfBoxes: "",
      packageInfo: "",
      invoiceNo: "",
      invoiceDate: "",
      invoiceValue: "",
      eWayBillNo: "",
      boxDimension: "",
      packageType: "",
      saidToContain: "",
      riskCoverage: "",
      policyValidity: "",
      paymentMode: {
        cash: false,
        dd: false,
        cheque: false,
      },
      codAmount: "",
      amountInWords: "",
      numberOfDocuments: "",
      documentsReceived: {
        invoice: false,
        eWaybill: false,
        others: false,
      },
      valueAddedService: {
        appointmentDelivery: false,
        specialDelivery: false,
      },
      // pickUpAgentName: "",
      actualWeight: "",
      chargedWeight: "",
      paymentType: {
        credit: false,
        paid: false,
        fod: false,
      },
      charges: {
        baseFreight: "",
        processingCharge: "",
        fuelSurcharge: "",
        rovCharge: "",
        fodCharge: "",
        handlingCharge: "",
        codDodCharge: "",
        specialDelivery: "",
        otherCharges: "",
        subTotal: "",
        gst: "",
        grandTotal: "",
      },
      modeOfPayment: {
        cash: false,
        chequeDd: false,
        neftRtgs: false,
      },
      chequeNeftNo: "",
      bank: "",
      amountInWordsPayment: "",
    });
  };

  const handleSubmit = async () => {
    try {
      const now = new Date();

      if (!user?.branch?.id && !user?.branch?.code) {
        toast.error("User branch information is missing.");
        return;
      }
      if (
        !formData?.docketNumber ||
        !formData?.origin ||
        !formData?.destination ||
        !formData?.from?.name ||
        !formData?.to?.name ||
        !formData?.from?.address ||
        !formData?.to?.address ||
        !formData?.from?.phoneNo ||
        !formData?.to?.phoneNo ||
        !formData?.actualWeight ||
        !formData?.chargedWeight ||
        !formData?.numberOfBoxes ||
        !formData?.boxDimension ||
        !(
          formData?.paymentType?.credit ||
          formData?.paymentType?.paid ||
          formData?.paymentType?.fod
        )
      ) {
        toast.error("Please fill in all required fields.");
        return;
      }
      setIsLoading(true);
      const body = {
        ...formData,
        docketNoMode: formData?.docketNoMode || "auto",
        branchID: user?.branch?.id,
        branchCode: user?.branch?.code,
        bookingDate: now.toISOString().split("T")[0],
        bookingTime: now.toTimeString().split(" ")[0],
      };
      // console.log("payload body", body);
      const res = await submitDocketEntry(body);
      if (res?.status === 201) {
        toast.success(
          `Docket ${res?.data?.docketEntry?.docketNumber || ""} submitted successfully`,
        );
        handleClear();
        console.log("Docket entry submitted successfully:", res);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error);
      console.log("Error submitting docket entry:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.branch?.id) {
      setFormData((prev) => ({
        ...prev,
        origin: user?.branch?.name || "",
      }));
    }
  }, [user]);
  console.log("User-->", user);
  return (
    <div className="bg-slate-200 min-h-screen p-4">
      <SectionHeader
        title="Docket Entry"
        subTitle="Fill in the details below to create a new docket entry."
      />
      <DocketForm formData={formData} setFormData={setFormData} />
      {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
      <div className="flex justify-end mt-3">
        <div
          className="px-10  py-1 rounded border border-sky-600 text-sm bg-sky-500 text-white cursor-pointer hover:bg-sky-700"
          onClick={handleSubmit}
        >
          {isLoading ? "Loading..." : "Save"}
        </div>
      </div>
    </div>
  );
};

export default DockerEntry;
